import React from "react";
import styled from "styled-components";
import { FaPen, FaSignOutAlt } from "react-icons/fa";

const EditProfileSection = ({ onEditUsername, onEditClan, onEditComunidad, onLogout }) => (
  <Grid>
    <ActionRow onClick={onEditUsername}>
      <ActionIcon><FaPen /></ActionIcon>
      <ActionLabel>EDITAR NOMBRE</ActionLabel>
      <ActionArrow>→</ActionArrow>
    </ActionRow>
    <Divider />
    <ActionRow onClick={onEditClan}>
      <ActionIcon><FaPen /></ActionIcon>
      <ActionLabel>EDITAR CLAN</ActionLabel>
      <ActionArrow>→</ActionArrow>
    </ActionRow>
    <Divider />
    <ActionRow onClick={onEditComunidad}>
      <ActionIcon><FaPen /></ActionIcon>
      <ActionLabel>EDITAR COMUNIDAD</ActionLabel>
      <ActionArrow>→</ActionArrow>
    </ActionRow>
    <Divider />
    <ActionRow $danger onClick={onLogout}>
      <ActionIcon $danger><FaSignOutAlt /></ActionIcon>
      <ActionLabel $danger>CERRAR SESIÓN</ActionLabel>
      <ActionArrow $danger>→</ActionArrow>
    </ActionRow>
  </Grid>
);

const Grid = styled.div`
  display: flex;
  flex-direction: column;
`;

const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 0.5rem;
  cursor: pointer;
  border-radius: 12px;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ $danger }) =>
      $danger ? "rgba(255, 59, 59, 0.04)" : "rgba(60, 255, 208, 0.03)"};
  }
`;

const ActionIcon = styled.span`
  font-size: 12px;
  color: ${({ $danger }) => ($danger ? "#ff3b3b" : "var(--v-fg-muted)")};
  width: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ActionLabel = styled.span`
  flex: 1;
  font-family: var(--v-font-mono);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ $danger }) => ($danger ? "#ff3b3b" : "var(--v-fg)")};
`;

const ActionArrow = styled.span`
  font-family: var(--v-font-mono);
  font-size: 13px;
  color: ${({ $danger }) => ($danger ? "rgba(255,59,59,0.4)" : "var(--v-fg-muted)")};
  opacity: 0.4;
`;

const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.04);
`;

export default EditProfileSection;
